import React from 'react';
import styled from 'styled-components';
import { Header, Footer, Navbar, Breadcums, ThemeWrapper } from 'components';
import { isEmpty } from 'lodash';
import { navigate, useLocationChange } from 'raviger';
import { getCurrentUser } from 'utils/getCurrentUser'
import { RETAIN_FILTER_PATHS, DEFAULT_SEARCH_FILTER } from 'utils/constants'
import { useProgramContext } from 'providers/programProvider'
import { useLinks } from 'hooks/useLinks'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  /* the 100 viewport height - the total pixel of te header and footer */
  min-height: calc(100vh - 280px);
`;

const PrivateLayout = (props) => {
  const user = getCurrentUser()
  if (isEmpty(user)) setTimeout(() => navigate('/login'))

  const [, dispatch] = useProgramContext()
  useLinks()
  useLocationChange((path) => {
    const filtered = RETAIN_FILTER_PATHS.filter((str) => path.indexOf(str) > -1);

    if (!filtered.length) {
      dispatch({ type: 'SET_PARAMS', payload: DEFAULT_SEARCH_FILTER })
    }
  })

  const Component = props.component;
  return !isEmpty(user) ? (
    <ThemeWrapper>
      <div>
        <Header />
        <Breadcums {...props} />
        <Content>
          <Component {...props} />
        </Content>
        <Footer />
      </div>
    </ThemeWrapper>
  ) : null;
};

export default PrivateLayout;
